import script from "./VisitTimeSlotGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitTimeSlotGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__